import { render, staticRenderFns } from "./include_current_situation.vue?vue&type=template&id=374be4e0&scoped=true&"
import script from "./include_current_situation.vue?vue&type=script&lang=js&"
export * from "./include_current_situation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374be4e0",
  null
  
)

export default component.exports